module.exports = __webpack_public_path__ + "baec39a4c4e7141319d40290c7f4e323.pdf";